import { Component, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { LayerService } from '@tt-lib/services/layers/layer.service'
import { MapService } from '@tt-lib/services/map.service'
import BaseLayer from 'ol/layer/Base';
import { Group as OlLayerGroup } from 'ol/layer';
import TileWMS from 'ol/source/TileWMS';
import { Observable, Subject, Subscription } from 'rxjs';
import { ToggleEventNameType, ToggleEventService } from '@tt-lib/services/toggle-event.service';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { NavigationBar } from '@capgo/capacitor-navigation-bar';

@Component({
  selector: 'tt-theme-switch',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
  standalone: true
})
export class ThemeSwitchComponent implements OnInit {
  @Input() showAsIcon: boolean;
  private lightTheme: string = 'ngi-theme-light';
  private darkTheme: string = 'ngi-theme-dark';
  public darkActive: WritableSignal<boolean> = signal(false);
  private _subscriptions = new Subscription();

  constructor(private layerService: LayerService,
    private toggleEventService: ToggleEventService,
    private mapService: MapService) { }

  ngOnInit(): void {
    setTimeout(async () => {
      // console.log("themeswitch init")
      let htmlEl = document.getElementsByTagName("html")[0];
      //theme in localstorage
      // if (localStorage.getItem('theme')) {
      //   // (localStorage.getItem('theme') === 'dark') ? htmlEl.classList.add(this.darkTheme) : htmlEl.classList.add(this.lightTheme);
      //   if (localStorage.getItem('theme') === 'dark') {
      //     htmlEl.classList.add(this.darkTheme);
      //     this.darkActive.set(true)
      //   } else {
      //     htmlEl.classList.add(this.lightTheme);
      //     this.darkActive.set(false);
      //   }
      // }
      // else {
      //os theme
      const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
      if (prefersDarkScheme.matches) {
        htmlEl.classList.add(this.darkTheme);
        this.darkActive.set(true);
      } else {
        htmlEl.classList.add(this.lightTheme);
        this.darkActive.set(false);
      }
    }
      , 0);

  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    this._subscriptions.add(
      this.layerService.baseLayersReady$.subscribe((isReady) => {
        if(!isReady){
          return;
        }
        setTimeout(() => {
          this.toggleEventService.toggleEvent(
            {
              forwardedFor: 'theme-switch',
              eventName: this.darkActive() ? ToggleEventNameType.DARK_THEME : ToggleEventNameType.LIGHT_THEME
            }
          );

          if (Capacitor.isNativePlatform()) {
            this.updateStatusAndNavigationBarColors();
          }
        }, 300);
      })
    )
    this._subscriptions.add(this.layerService.getSelectedBaselayer$().subscribe(_ => {
      this.setBgColorForJpegTiles()
      this.layerService.setCrossborderOpacity(this.darkActive() ? ToggleEventNameType.DARK_THEME : ToggleEventNameType.LIGHT_THEME);
    }
    ));
  }

  async switchTheme() {
    let htmlEl = document.getElementsByTagName("html")[0];
    if (htmlEl.classList.contains(this.lightTheme)) {
      htmlEl.classList.remove(this.lightTheme);
      htmlEl.classList.add(this.darkTheme);
      localStorage.setItem('theme', 'dark');
      this.darkActive.set(true);
    } else {
      htmlEl.classList.add(this.lightTheme);
      htmlEl.classList.remove(this.darkTheme);
      localStorage.setItem('theme', 'light');
      this.darkActive.set(false);
    }
    this.setBgColorForJpegTiles();
    this.toggleEventService.toggleEvent(
      {
        forwardedFor: 'theme-switch',
        eventName: this.darkActive() ? ToggleEventNameType.DARK_THEME : ToggleEventNameType.LIGHT_THEME
      }
    );

    if (Capacitor.isNativePlatform()) {
      this.updateStatusAndNavigationBarColors();
    }
  }

  private setBgColorForJpegTiles() {
    this.mapService.getMap().getLayers().forEach((lyrOrGrp: any) => {
      if (lyrOrGrp instanceof OlLayerGroup) {
        (<any>lyrOrGrp.getLayers()).forEach(lyr => {
          if (lyr.getSource() instanceof TileWMS) {
            this.setParams(lyr.getSource());
          }
        });
      }
      else {
        if (lyrOrGrp.getSource() instanceof TileWMS) {
          this.setParams(lyrOrGrp.getSource());
        }
      }
    })
  }

  private setParams(src) {
    let params = src.getParams();
    if (params.FORMAT.toLowerCase() === 'image/jpeg') {
      params.BGCOLOR = this.darkActive() ? '0x1c1b1c' : '0xfcf8f9';
      params.TRANSPARENT = false;
      //params.t = new Date().getMilliseconds();
      src.updateParams(params);
    }
  }

  private async updateStatusAndNavigationBarColors() {
    if (Capacitor.isNativePlatform()) {
      //only for android
      if (Capacitor.getPlatform() === 'android') {
        await StatusBar.setOverlaysWebView({ overlay: false });
        await StatusBar.show();
        //await StatusBar.setBackgroundColor({ color: this.darkActive() ? '#1e1e1e' : '#ffffff' });
        await StatusBar.setStyle({ style: this.darkActive() ? Style.Dark : Style.Light });
        await NavigationBar.setNavigationBarColor({
          color: '#ffffff00',    //background
          darkButtons: true    // button color
        });
      }
      //ios
      if (Capacitor.getPlatform() === 'ios') {
        document.body.classList.add('ios');
        // const safeTop = window.visualViewport?.offsetTop || 84; // fallback to 44
        await StatusBar.setOverlaysWebView({ overlay: true });
        await StatusBar.show();
        await StatusBar.setStyle({ style: this.darkActive() ? Style.Dark : Style.Light });
        document.documentElement.style.setProperty('--safe-top', 'env(safe-area-inset-top)');
      }
    }
  }
}